<template>
  <div class="alert-info sticky">
    <div class="icon">
      <i class="af-icons-md af-icons-md-circle-processing"></i>
    </div>
    <div class="message">
      <p>{{ translations.inProgressMessage }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    translations: {
      type: Object,
      required: true,
    },
  },
};
</script>
